module.exports = __webpack_public_path__ + "img/agrégat-compacté-sm.3f61f056.jpg";